// src/social/caption-templates.js
// Caption templates for social media posts

export const hooks = {
  emoji: ["🏨", "🛏️", "🚗", "✨", "🌟", "💰", "📍", "🎯", "🔥", "💫", "🌙", "☀️", "💎", "🏆", "🎉", "🎊", "👍", "❤️", "🏖️", "🌴", "🎪", "🎭", "🛍️", "🍽️"],
  words: ["Looking for", "Need a", "Want a", "Searching for", "Planning a trip to", "Visiting", "Traveling to", "Exploring", "Discovering", "Enjoying", "Heading to", "Road-tripping through", "Stopping by", "Passing through", "Staying in", "Vacationing in", "Cruising through", "Touring", "Wandering through", "Checking out"],
  questions: ["Did someone say", "Ready for", "How about", "Ever tried", "Why not", "Imagine a", "Picture this:", "What if", "Who's up for", "Time for", "Feeling like", "Craving a"]
};

export const templates = {
  room: [
    "{hook} {roomFeature} at {propertyName}. {benefit}. Book now!",
    "Rest easy at {propertyName} 🌙 {roomDescription}. Reserve today!",
    "Your perfect room awaits at {propertyName} {hook} {roomFeature}. Book direct!",
    "{propertyName} offers {roomFeature} in {city}. Clean, comfortable, affordable.",
    "Book a room at {propertyName} — quality stays at great prices.",
    "Cozy rooms, great prices at {propertyName} {hook} {roomFeature}. Book today!",
    "{propertyName} has the perfect room for your next trip. {roomFeature}.",
    "Stay in comfort at {propertyName} {hook} {roomDescription}. Book now!",
    "{hook} {roomFeature} just minutes from {landmark}. That's {propertyName}.",
    "Treat yourself to {roomFeature} at {propertyName}. You deserve it.",
    "Road trip? {propertyName} has {roomFeature} waiting for you.",
    "Budget-friendly {roomFeature} at {propertyName}. No compromises on comfort.",
    "Wake up refreshed at {propertyName} — {roomFeature} + {amenity}.",
    "{propertyName}: where {roomFeature} meets {city} hospitality.",
    "Your {city} home base: {propertyName} with {roomFeature}.",
    "Quality {roomFeature} without the premium price tag. {propertyName}.",
    "Book direct at {propertyName} and save. {roomFeature} guaranteed.",
    "{propertyName} — {roomFeature} for every budget. Reserve today!",
    "Looking for {roomFeature} near {landmark}? {propertyName} is your answer.",
    "Late checkout? Early check-in? {propertyName} has {roomFeature} on your schedule.",
    "Sleep like royalty at {propertyName}. {roomFeature} included.",
    "New to {city}? Stay at {propertyName} — {roomFeature} + local tips.",
    "Business trip? {propertyName} has {roomFeature} + {amenity}.",
    "Family vacation? {propertyName} offers {roomFeature} for everyone.",
    "Your {occasion} starts at {propertyName}. {roomFeature} guaranteed.",
    "Clean, modern, affordable. {propertyName} delivers {roomFeature}.",
    "Traveling on a budget? {propertyName} has {roomFeature} at great rates.",
    "{propertyName} — where {roomFeature} meets exceptional service.",
    "From {landmark} to your pillow — {propertyName} is just minutes away.",
    "Don't settle for less. {propertyName} offers {roomFeature} at the best price.",
    "Weekend plans? {propertyName} has {roomFeature} ready for you.",
    "Stay smarter at {propertyName}. {roomFeature} + {amenity}."
  ],
  lobby: [
    "{hook} Welcome to {propertyName}! {greeting}. Book today!",
    "Check in, relax, enjoy {city} from {propertyName} {hook} {greeting}.",
    "{propertyName} — where every guest is family {hook} {greeting}.",
    "Friendly faces at {propertyName} {hook} {greeting}. Your home in {city}.",
    "Welcome to {propertyName} in {city}! {hook} {greeting}.",
    "At {propertyName}, we make you feel at home {hook} {greeting}.",
    "Walk in as a guest, leave as family. {propertyName} {hook} {greeting}.",
    "The moment you walk in, you'll know you chose right. {propertyName}.",
    "First impressions matter. {propertyName} delivers {hook} {greeting}.",
    "Our lobby, your living room. {propertyName} welcomes you.",
    "24/7 front desk, always with a smile. {propertyName} {hook} {greeting}.",
    "Check in stress-free at {propertyName}. We handle the rest.",
    "From check-in to check-out, {propertyName} has you covered.",
    "Meet our team at {propertyName} — we're here to help.",
    "At {propertyName}, hospitality isn't just a word — it's our promise.",
    "Step into {propertyName} and feel the warmth of {city}.",
    "Your journey begins at {propertyName}. Welcome!",
    "We don't just check you in — we welcome you home. {propertyName}.",
    "Coffee, smiles, and a warm welcome. That's {propertyName}.",
    "Need help planning your {city} trip? We're at the front desk!",
    "Arrive stressed, leave refreshed. That's the {propertyName} experience.",
    "From luggage to latte — we've got you covered at {propertyName}.",
    "Welcome to your home away from home in {city}.",
    "Check in anytime — our doors are always open. {propertyName}.",
    "Smiles are complimentary at {propertyName}. Welcome!"
  ],
  offer: [
    "💰 Deal at {propertyName}! {offerDetails}. Book now!",
    "Weekend special at {propertyName} {hook} {offerDetails}. Reserve today!",
    "Save big at {propertyName} {hook} {offerDetails}. Book now!",
    "{propertyName} has availability this week! {offerDetails}.",
    "Last-minute rooms at {propertyName}! {offerDetails}.",
    "Special offer: {offerDetails} at {propertyName}.",
    "{hook} {propertyName} deal: {offerDetails}. Limited time!",
    "Flash sale! {offerDetails} at {propertyName}. Don't miss out.",
    "This week only: {offerDetails}. {propertyName}.",
    "Book early, save more. {offerDetails} at {propertyName}.",
    "Extended stay? {offerDetails} at {propertyName}.",
    "Group booking? {offerDetails} at {propertyName}.",
    "AAA members: {offerDetails} at {propertyName}.",
    "Direct booking bonus: {offerDetails}. Only at {propertyName}.",
    "Spring into savings: {offerDetails} at {propertyName}.",
    "Summer rates just dropped: {offerDetails}. {propertyName}.",
    "Fall into comfort: {offerDetails} at {propertyName}.",
    "Winter escape: {offerDetails} at {propertyName}.",
    "Stay 3 nights, pay for 2. {propertyName}.",
    "Midweek magic: {offerDetails} at {propertyName}.",
    "Hot deal alert! {offerDetails} at {propertyName}.",
    "Your wallet will thank you. {offerDetails} at {propertyName}.",
    "Limited rooms at this price. {offerDetails}. {propertyName}.",
    "Book direct, save big. {offerDetails} at {propertyName}.",
    "Why pay more? {offerDetails} at {propertyName}.",
    "Travel more, spend less. {offerDetails} at {propertyName}.",
    "This deal won't last. {offerDetails} at {propertyName}.",
    "Upgrade your stay for less. {offerDetails} at {propertyName}.",
    "Price drop! {offerDetails} at {propertyName}. Hurry!",
    "Exclusive online rate: {offerDetails}. {propertyName}.",
    "Member exclusive: {offerDetails} at {propertyName}.",
    "Early bird gets the deal. {offerDetails} at {propertyName}.",
    "Stay longer, pay less. {offerDetails} at {propertyName}."
  ],
  attraction: [
    "Explore {city} from {propertyName} {hook} {attraction}. Book today!",
    "{propertyName} is near {landmark} {hook} Perfect for your trip.",
    "Discover {city}'s best: {attraction}. Stay at {propertyName}.",
    "{hook} Visit {landmark} while staying at {propertyName}.",
    "{city} adventure starts at {propertyName} {hook} {attraction}.",
    "Steps from {landmark}, home at {propertyName}.",
    "{attraction} + comfort = perfect {city} trip. {propertyName}.",
    "Your {city} itinerary starts here. {propertyName} near {landmark}.",
    "Shopping at {landmark}? Rest at {propertyName}.",
    "Catch a show near {landmark}, sleep at {propertyName}.",
    "Foodie tour of {city}? {propertyName} is your base.",
    "{landmark} is calling. {propertyName} is waiting.",
    "Stay near {landmark} at {propertyName}. Best rates guaranteed.",
    "{city} highlights near {propertyName}: {attraction}.",
    "Make {landmark} part of your stay at {propertyName}.",
    "Theme parks, beaches, museums — {city} has it all. Stay at {propertyName}.",
    "Wine tasting? Hiking? Shopping? {city} awaits. Stay at {propertyName}.",
    "Date night in {city}? {propertyName} is your perfect base.",
    "Sightseeing in {city}? Rest at {propertyName} after a long day.",
    "{landmark} + {propertyName} = perfect {city} getaway.",
    "Explore {city} by day, relax at {propertyName} by night.",
    "Your {city} adventure starts at {propertyName}. Book now!",
    "Near {landmark}, close to everything. That's {propertyName}.",
    "Discover hidden gems in {city}. Stay at {propertyName}.",
    "{attraction} is just around the corner from {propertyName}.",
    "Catch the sunset at {landmark}, then sleep at {propertyName}.",
    "Live music, great food, {city} nightlife — then rest at {propertyName}.",
    "Beach day? {propertyName} is your coastal getaway.",
    "Mountain views, city vibes — {city} has it all. Stay at {propertyName}.",
    "Art, culture, history — {city} is calling. Stay at {propertyName}.",
    "Food festivals, street fairs, local markets — {city} awaits. Stay at {propertyName}.",
    "Make memories at {landmark}. Sleep comfortably at {propertyName}."
  ],
  review: [
    "⭐ See why guests love {propertyName}! Book your stay today.",
    "Don't just take our word for it — {propertyName} delivers.",
    "Rated excellent by travelers! {propertyName} offers the best.",
    "Guests choose {propertyName} again and again.",
    "Join satisfied guests who chose {propertyName}.",
    "5-star experience at {propertyName}. Book and see why!",
    "Guests say: '{guestQuote}' — {propertyName}.",
    "What our guests are saying about {propertyName}.",
    "Excellence isn't optional at {propertyName}. It's standard.",
    "Why travelers love {propertyName}: {guestReview}.",
    "Your comfort, our priority. See {propertyName} reviews.",
    "Hospitality at its finest — {propertyName}.",
    "Experience the {propertyName} difference. Book now!",
    "Guest satisfaction guaranteed at {propertyName}.",
    "Making memories at {propertyName}. See our reviews.",
    "Clean, friendly, affordable — that's {propertyName}.",
    "Travelers rate {propertyName} as a top pick in {city}.",
    "From families to business travelers — everyone loves {propertyName}.",
    "Our guests are our best marketers. See what they say!",
    "Rated #1 for value in {city}. That's {propertyName}.",
    "Repeat guests know best. {propertyName} delivers every time.",
    "Your neighbors loved {propertyName}. You will too.",
    "Overwhelmed with 5-star reviews. {propertyName} thanks you.",
    "Where every stay is a 5-star experience. {propertyName}.",
    "Guests come for the price, stay for the experience. {propertyName}.",
    "See why we're {city}'s hidden gem. Book {propertyName} today.",
    "Trust the reviews — {propertyName} is worth every penny.",
    "Travelers talk, and they love {propertyName}.",
    "Your next favorite hotel is {propertyName}.",
    "Real guests, real reviews, real love for {propertyName}.",
    "Don't just book a room — book a 5-star experience at {propertyName}."
  ],
  seasonal: [
    "🎉 Celebrate the season at {propertyName}! Special packages available.",
    "Season's greetings from {propertyName}! Make your stay memorable.",
    "This season, treat yourself to {propertyName}. Book now!",
    "{season} special at {propertyName}. Limited time offer!",
    "The perfect {season} escape awaits at {propertyName}.",
    "{propertyName} is ready to make your {season} special!",
    "Holiday rates at {propertyName}. Book your getaway!",
    "Summer vibes at {propertyName}. Pool + comfort = perfect stay.",
    "Winter warmth at {propertyName}. Cozy rooms, great rates.",
    "Spring into savings at {propertyName}. New season, new deals.",
    "Fall into comfort at {propertyName}. Autumn special rates.",
    "Celebrate {holiday} at {propertyName}. Special packages available.",
    "{season} in {city} = {propertyName} + savings.",
    "Your {season} getaway starts at {propertyName}.",
    "Make this {season} unforgettable. Stay at {propertyName}.",
    "{season} is here! Book your {city} escape at {propertyName}.",
    "Cherry blossoms or pumpkin spice — {season} at {propertyName} is magical.",
    "{holiday} getaway at {propertyName}. Book before it's gone!",
    "Snow day? Beach day? {season} vibes at {propertyName}.",
    "{propertyName}'s {season} sale is on. Don't miss out!",
    "New season, new reasons to visit {propertyName}.",
    "{season} adventures in {city} start at {propertyName}.",
    "Celebrate {holiday} with special rates at {propertyName}.",
    "The best {season} deals are at {propertyName}. Book direct!",
    "{season} in {city} is better at {propertyName}.",
    "Your {holiday} home base: {propertyName}.",
    "{propertyName}'s {season} packages are here. Book now!",
    "Sunshine, snow, or leaves — {season} at {propertyName} is always great.",
    "Limited-time {season} rates at {propertyName}. Hurry!",
    "Make {holiday} special with a stay at {propertyName}.",
    "{season} + {city} + {propertyName} = perfect getaway.",
    "Fall leaves, winter snow, spring blooms — {propertyName} has you covered."
  ]
};

export const roomFeatures = [
  "modern rooms", "cozy beds", "clean rooms", "comfortable stay",
  "affordable rooms", "quality accommodation", "great value",
  "spacious rooms", "quiet rooms", "restful sleep", "fresh linens",
  "flat-screen TV", "free WiFi", "air conditioning", "mini fridge",
  "microwave", "coffee maker", "work desk", "blackout curtains",
  "pillow-top mattresses", "luxury bedding", "soundproof rooms",
  "city views", "garden views", "private balcony", "rain shower",
  "granite countertops", "hardwood floors", "modern decor",
  "USB charging ports", "smart TV", "fully furnished rooms"
];

export const amenities = [
  "free parking", "24-hour front desk", "free WiFi", "swimming pool",
  "continental breakfast", "fitness center", "business center",
  "laundry service", "airport shuttle", "pet-friendly", "ADA accessible",
  "non-smoking rooms", "vending machines", "ice machines",
  "electric vehicle charging", "bbq area", "garden",
  "meeting rooms", "concierge service", "room service"
];

export const greetings = [
  "Welcome aboard!", "Come on in!", "Glad you're here!",
  "Hospitality at its best.", "We're ready for you.",
  "Your comfort is our mission.", "Home away from home.",
  "Where guests become family.", "Enjoy your stay.",
  "We're here to help.", "Feel at home.", "Relax and unwind.",
  "Let the journey begin!", "Welcome to paradise!", "So glad you found us!",
  "You've made the right choice!", "Sit back, we've got this.",
  "Your adventure starts here!", "Make yourself at home.",
  "We've been expecting you!", "Welcome to the family!"
];

export const occasions = [
  "vacation", "business trip", "weekend getaway", "road trip",
  "family vacation", "couple's retreat", "solo adventure",
  "work trip", "conference", "wedding", "family reunion",
  "concert", "sporting event", "festival", "holiday",
  "anniversary", "birthday trip", "graduation trip", "babymoon",
  "girls' trip", "guys' trip", "study session", "writing retreat"
];

export const cities = [
  // San Gabriel Valley
  "Montebello", "Rosemead", "San Gabriel", "Alhambra", "Monterey Park",
  "Temple City", "Arcadia", "Duarte", "Azusa", "Glendora", "Covina",
  "West Covina", "Baldwin Park", "El Monte", "South El Monte", "Irwindale",
  "La Puente", "Hacienda Heights", "Rowland Heights", "Walnut", "Diamond Bar",
  "Claremont", "Pomona", "San Dimas", "La Verne", "Bradbury",
  // San Fernando Valley
  "Glendale", "Burbank", "North Hollywood", "Studio City", "Sherman Oaks",
  "Encino", "Tarzana", "Woodland Hills", "Calabasas", "Agoura Hills",
  "Westlake Village", "Thousand Oaks", "Simi Valley", "Moorpark",
  "Canoga Park", "Winnetka", "Chatsworth", "Northridge", "Reseda",
  "Van Nuys", "Panorama City", "Arleta", "Pacoima", "Sylmar",
  // Westside & Coastal
  "Santa Monica", "Venice", "Culver City", "Mar Vista", "Playa del Rey",
  "Manhattan Beach", "Hermosa Beach", "Redondo Beach", "Torrance",
  "Palos Verdes Estates", "Rancho Palos Verdes", "Rolling Hills",
  "Beverly Hills", "West Hollywood", "Century City", "Westwood",
  "Brentwood", "Pacific Palisades", "Malibu",
  // South Bay & Harbor
  "Long Beach", "San Pedro", "Wilmington", "Carson", "Compton",
  "Lynwood", "South Gate", "Downey", "Norwalk", "Santa Fe Springs",
  "Paramount", "Bellflower", "Lakewood", "Cerritos", "Artesia",
  "Bell Gardens", "Bell", "Maywood", "Huntington Park", "Florence",
  // Downtown & Central LA
  "Downtown LA", "Koreatown", "Mid-Wilshire", "Pico-Robertson",
  "Fairfax", "Little Tokyo", "Arts District", "Chinatown",
  "Echo Park", "Silver Lake", "Los Feliz", "Atwater Village",
  "Highland Park", "Eagle Rock", "Glassell Park", "Mount Washington",
  "Boyle Heights", "East LA", "Lincoln Heights", "City Terrace",
  // Antelope Valley & North
  "Lancaster", "Palmdale", "Santa Clarita", "Valencia", "Saugus",
  "Canyon Country", "Newhall", "Acton", "Littlerock",
  // Inland Empire (nearby)
  "Rancho Cucamonga", "Ontario", "Upland", "Fontana", "Rialto",
  "San Bernardino", "Redlands", "Riverside", "Moreno Valley",
  "Corona", "Norco", "Eastvale", "Jurupa Valley"
];

export const landmarks = [
  // Beaches
  "Santa Monica Pier", "Venice Beach", "Manhattan Beach", "Hermosa Beach",
  "Redondo Beach", "Long Beach Pier", "Laguna Beach", "Huntington Beach",
  "Zuma Beach", "El Matador Beach", "Point Dume", "Santa Catalina Island",
  "Malibu", "Dockweiler Beach", "Rosie's Dog Beach",
  // Mountains & Cold Places
  "Big Bear Lake", "Lake Arrowhead", "Mount Baldy", "Angeles National Forest",
  "Running Springs", "Wrightwood", "Idyllwild", "Julian",
  "Mammoth Lakes", "Lassen Volcanic National Park",
  // Lakes
  "Lake Tahoe", "Castaic Lake", "Silverwood Lake", "Piru Lake",
  "Lake Balboa", "Echo Park Lake", "Lake Hollywood", "Kenneth Hahn Lake",
  // LA Tourist Spots
  "Hollywood Sign", "Griffith Observatory", "Universal Studios",
  "Disneyland", "Disney California Adventure", "Santa Monica Boulevard",
  "Beverly Hills", "Rodeo Drive", "Sunset Boulevard", "Mulholland Drive",
  "La Brea Tar Pits", "The Original Farmers Market", "The Grove",
  "Grand Central Market", "Olvera Street", "Chinatown", "Little Tokyo",
  "Korean Town", "Melrose Avenue", "Abbot Kinney Boulevard",
  // Museums & Culture
  "The Getty Center", "LACMA", "The Broad", "California Science Center",
  "Natural History Museum", "GRAMM", "Autry Museum", "Petersen Automotive Museum",
  "Hammer Museum", "Norton Simon Museum", "Huntington Library",
  // Sports & Entertainment
  "SoFi Stadium", "Dodger Stadium", "Crypto.com Arena", "Hollywood Bowl",
  "Greek Theatre", "The Forum", "Rose Bowl", " Banc of California Stadium",
  // Nature & Parks
  "Griffith Park", "Runyon Canyon", "Bronson Canyon", "TreePeople Park",
  "Descanso Gardens", "Huntington Botanical Gardens", "Arboretum",
  "Venice Canals", "Ballona Creek Bike Path",
  // Shopping & Dining
  "Westfield Century City", "The Americana at Brand", "South Coast Plaza",
  "Burbank Town Center", "Glendale Galleria", "Hollywood & Highland"
];

export const seasons = ["Spring", "Summer", "Fall", "Winter"];

export const holidays = [
  "New Year", "Valentine's Day", "Easter", "Mother's Day",
  "Father's Day", "Independence Day", "Labor Day",
  "Halloween", "Thanksgiving", "Christmas", "New Year's Eve",
  "Memorial Day", "Presidents' Day", "Columbus Day"
];

export const guestQuotes = [
  "Best stay ever!", "Highly recommend!", "Will definitely return!",
  "Perfect location!", "Great value for money!", "So comfortable!",
  "Amazing service!", "Clean and modern!", "Loved it!",
  "Exceeded expectations!", "Will book again!", "Five stars!",
  "Best hotel experience!", "Absolutely wonderful!", "Will tell my friends!",
  "Hidden gem!", "Surprisingly good!", "Better than expected!",
  "Top-notch service!", "Couldn't ask for more!", "A+ experience!",
  "Made our trip special!", "So glad we stayed here!", "Perfect in every way!"
];

export const offerDetails = [
  "Book now and save 20%", "Stay 3 nights, pay for 2",
  "Free breakfast included", "Late checkout at no extra cost",
  "Room upgrade available", "Weekend rates starting at $89",
  "Extended stay discounts", "AAA member discount",
  "Military discount available", "Book direct and save 15%",
  "First-time guest special", "Referral bonus available",
  "Free parking + WiFi included", "Stay more, save more",
  "Kids stay free", "Complimentary welcome drink",
  "Free airport shuttle", "Early check-in available",
  "Birthday month special", "Loyalty rewards program",
  "Corporate rates available", "Group discounts for 5+ rooms"
];

export const benefits = [
  // General
  "Best rates guaranteed", "No booking fees", "Free cancellation",
  "Instant confirmation", "Flexible check-in", "Complimentary breakfast",
  "Free parking included", "24/7 customer support",
  "No hidden fees", "Price match guarantee", "Flexible dates",
  "Exclusive member rates", "Loyalty rewards", "Refer a friend bonus",
  // ADA & Accessibility
  "ADA accessible rooms available", "Wheelchair accessible entrance",
  "Roll-in showers available", "Grab bars in bathroom",
  "Elevator access to all floors", "Accessible parking spaces",
  "Visual alarm devices available", "Braille signage throughout",
  "Service animals always welcome", "Service dogs welcome at no extra charge",
  "Mobility assistance available", "Accessible common areas",
  "Lowered light switches and fixtures", "Wheelchair accessible pool lift",
  // Service Animals
  "Service dogs welcome per ADA", "No pet fees for service animals",
  "Service animal relief area on-site", "Staff trained on ADA service animal rules",
  "Emotional support animals welcome", "Service animals always welcome free of charge",
  // Additional Amenities
  "Free WiFi everywhere", "No resort fees", "Kids stay free",
  "Extended stay discounts", "Military & veteran discounts",
  "Senior citizen discounts", "Corporate rates available"
];
